import FileSaver from 'file-saver';

const expDisputesData = (exportData:any) => {
    const expAge = [{}];
    for (let i = 0; i < exportData.length; i++) {
        expAge.push({
            'Employee Name': `${exportData[i].employeeName}`,
            'Scorecard Role': `${exportData[i].scorecardRole}`,
            'Scorecard Name': `${exportData[i].scorecardName}`,
            'Dispute Status': `${exportData[i].disputeStatus}`,
            'Dispute Created Date': `${exportData[i].disputeCreatedDate}`,
            'Resolution Date': `${exportData[i].resolutionDate}`,
            'Dispute Reason': `${exportData[i].disputeReason}`,
            'Dispute Type': `${exportData[i].disputeType}`,
            'Date of Dispute': `${exportData[i].dateofDispute}`,
            'Dispute Comment': `${exportData[i].disputeComment}`,
            'Resolution Comment': `${exportData[i].resolutionComment}`,
            'Metric': `${exportData[i].metric}`,
            'Proposed Value': `${exportData[i].proposedValue}`,
            'Dispute Created By': `${exportData[i].disputeCreatedBy}`,
            'Dispute Resolved By': `${exportData[i].disputeResolvedBy}`,
            'Resolution Reason': `${exportData[i].resolutionReason}`,
            'Disputed Value': `${exportData[i].disputedValue}`,
        });
    }
    return expAge;
};
export const exportExcel = (data: any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(expDisputesData(data));
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'all_disputes');
    });
};
export const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};
export const getValue = (value: any) => {
    if (value === '' || value === null || value === undefined)
        return '--';
    else
        return value;
}
